<template>
    <div class="Page">
      <Header Act="8"></Header>
      <div class="MaxWid">
        <div class="MarTop">
          <div class="AboutPos">当前位置：公示信息</div>
        </div>
        <div class="Nav">
          <div class="NavItem" :class="{Act:i==2}" @click="ToggleNav(2)">专业人员公示</div>
          <div class="NavItem" :class="{Act:i==3}" @click="ToggleNav(3)">专业机构公示</div>
          <div class="NavItem" :class="{Act:i==4}" @click="ToggleNav(4)">伦理公示</div>
        </div>
        <div>
          <div class="QueryCont MarTop">
            <!-- 专业人员公示和专业机构公示 -->
            <div v-if="i === 2 || i === 3">
              <div class="QueryCard" v-for="item in InfoData" :key="item.id" @click="GoDetail(item,6)">
                <div class="QueryCardContent">
                  <div class="QueryCardTitle">{{ item.name }}</div>
                  <!-- <div class="QueryCardSubtitle">{{ item.id == 1 ? '初级' : item.id == 2 ? '中级' : '高级' }}注册心理咨询师</div>
                  <div v-if="item.code">注册号: {{ item.code }}</div>
                  <div class="State">
                    <div class="StateTit">注册状态</div>
                    <div class="StateTag" :class="[item.status=='hidden'?'BgBlue':(item.status=='publicity'||item.status=='normal')?'BgGreen':'BgRed']">
                      <span v-if="item.status=='hidden'">未审核</span>
                      <span v-if="item.status=='publicity'">公示中</span>
                      <span v-if="item.status=='normal'">公示完成</span>
                      <span v-if="item.status=='shenhe_hidden'">审核驳回</span>
                      <span v-if="item.status=='publicity_hidden'">公示驳回</span>
                    </div>
                  </div> -->
                  <div class="StateTit">{{ $Global.goTime(item.createtime) }}</div>
                </div>
              </div>
              <div class="PageDis" v-if="total > 0">
                <el-pagination
                  background
                  :page-sizes="[10, 20, 50]"
                  layout="prev,pager,next,total,sizes"
                  @size-change="SizeChange"
                  @current-change="PageChange"
                  :total="total"
                  :current-page="page"
                  :hide-on-single-page="false"
                ></el-pagination>
              </div>
            </div>
            <!-- 伦理公示，使用 Profession 的格式 -->
            <div v-if="i === 4">
              <div class="QueryContItem" v-for="item in ethicsCont" :key="item.id">
                <div class="QueryContItemTit" @click="GoEthicsDetail(item)">
                  <div class="iconfont icon-shujidaoru"></div>
                  <div>{{ item.title }}</div>
                </div>
                <div class="QueryContItemCont">
                  <div class="QueryContItemTxt">{{ item.synopsis }}</div>
                </div>
              </div>
              <div class="PageDis" v-if="ethicsTotal > 0">
                <el-pagination
                  background
                  :page-sizes="[10, 20, 50]"
                  layout="prev,pager,next,total,sizes"
                  @size-change="EthicsSizeChange"
                  @current-change="EthicsPageChange"
                  :total="ethicsTotal"
                  :current-page="ethicsPage"
                  :hide-on-single-page="false"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  </template>
  
  <script>
  import Header from '@/components/header/head';
  import Footer from '@/components/header/footer';
  import Banner from '@/components/banner/Banner';
  
  export default {
    components: { Header, Footer, Banner },
    data() {
      return {
        i: 2,
        InfoData: [],
        Data: "",
        total: 0,
        page: 1,
        SizePage: 10,
        // 伦理公示相关数据
        ethicsData: null, // Profession 中 Data 的 id == 1 数据
        ethicsCont: [], // 伦理公示内容
        ethicsTotal: 0, // 伦理公示总数
        ethicsPage: 1, // 伦理公示当前页
        ethicsSizePage: 10, // 伦理公示每页条数
      };
    },
    mounted() {
      this.GetData();
      this.Data = JSON.parse(localStorage.getItem("Info"));
      this.GetEthicsData(); // 获取伦理数据
    },
    methods: {
      // 获取公示数据
      GetData() {
        if (this.i === 4) {
          this.GetEthicsCont(this.ethicsData ? this.ethicsData.id : 1);
        } else {
          this.$post("api/index/registerList", {
            type: this.i,
            limit: this.SizePage,
            page: this.page,
          }).then(res => {
            if (res.data.code == 1) {
              this.InfoData = res.data.data.data || [];
              this.total = res.data.data.total || 0;
            } else {
              this.InfoData = [];
              this.total = 0;
            }
          }).catch(err => {
            this.$message.error("获取公示数据失败");
            console.error(err);
          });
        }
      },
      // 获取 Profession 的 Data 数据并筛选 id == 1
      GetEthicsData() {
        this.$get("api/index/occupationCategory").then(res => {
          if (res.data.code == 1) {
            const data = res.data.data;
            this.ethicsData = data.find(item => item.id === 1); // 筛选 id == 1
            if (this.i === 4 && this.ethicsData) {
              this.GetEthicsCont(this.ethicsData.id); // 如果初始选中伦理公示，加载内容
            }
          } else {
            this.$message.error(res.data.msg);
            this.ethicsData = null;
            this.ethicsCont = [];
            this.ethicsTotal = 0;
          }
        }).catch(err => {
          this.$message.error("获取伦理数据失败");
          console.error(err);
        });
      },
      // 获取 id == 1 的内容
      GetEthicsCont(id) {
        this.$post("api/index/occupation", {
          category_id: id,
          page: this.ethicsPage,
          limit: this.ethicsSizePage,
        }).then(res => {
          if (res.data.code == 1) {
            this.ethicsCont = res.data.data.data || res.data.data || [];
            this.ethicsTotal = res.data.data.total || 0;
          } else {
            this.ethicsCont = [];
            this.ethicsTotal = 0;
          }
        }).catch(err => {
          this.$message.error("获取伦理内容失败");
          console.error(err);
        });
      },
      // 切换导航
      ToggleNav(i) {
        this.i = i;
        this.page = 1;
        this.ethicsPage = 1; // 重置伦理公示页码
        this.GetData();
      },
      // 伦理公示分页
      EthicsSizeChange(val) {
        this.ethicsSizePage = val;
        this.ethicsPage = 1;
        this.GetEthicsCont(this.ethicsData.id);
      },
      EthicsPageChange(val) {
        this.ethicsPage = val;
        this.GetEthicsCont(this.ethicsData.id);
      },
      // 跳转到伦理详情页（与 Profession 一致）
      GoEthicsDetail(item) {
        // 同时保存到localStorage（向后兼容）和通过路由参数传递
        localStorage.setItem("Info", JSON.stringify(item));
        localStorage.setItem("InfoState", 7);
        this.$router.push({
          path: '/infoPublicity',
          query: {
            id: item.id,
            type: 7  // 7=伦理
          }
        });
      },
      // 跳转到详情页（与首页信息公示一致）
      GoDetail(item, num) {
        // 同时保存到localStorage（向后兼容）和通过路由参数传递
        localStorage.setItem("Info", JSON.stringify(item));
        localStorage.setItem("InfoState", num);
        this.$router.push({
          path: '/infoPublicity',
          query: {
            id: item.id,
            type: num
          }
        });
      },
      SizeChange(val) {
        this.SizePage = val;
        this.page = 1;
        this.GetData();
      },
      PageChange(val) {
        this.page = val;
        this.GetData();
      },
      GoPage(url) {
        this.$router.push({
          path: url
        });
      },
    },
  };
  </script>
  
  <style scoped>
  .Page {
    background: #fff;
  }
  
  .BgColorBlue {
    background-color: #037dbe;
  }
  
  .BgColorYellow {
    background-color: #ed8404;
  }
  
  .BgColorGreen {
    background-color: #82ae1d;
  }
  
  .MarTop {
    margin-top: 20px;
  }
  
  .MaxWid {
    max-width: 1180px;
    padding: 0 10px;
    margin: 0 auto;
  }
  
  .AboutPos {
    padding: 20px 0;
    font-size: 12px;
    color: #999999;
  }
  
  .Nav {
    display: flex;
    align-items: center;
    border-bottom: 2px solid #ddd;
    position: relative;
    margin-bottom: 20px;
  }
  
  .NavItem {
    font-size: 18px;
    padding: 15px;
    text-align: center;
    font-weight: 400;
    color: #666666;
    cursor: pointer;
    position: relative;
  }
  
  .NavItem.Act {
    color: #037dbe;
    font-weight: 600;
  }
  
  .NavItem.Act::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 2px;
    background: #037dbe;
    bottom: -2px;
    left: 0;
  }
  
  /* 复制 Profession 的样式 */
  .QueryContItemTit {
    padding: 15px;
    color: #fff;
    font-size: 18px;
    background: #0286eb;
    display: flex;
    cursor: pointer;
  }
  
  .QueryContItemTit .iconfont {
    margin-right: 10px;
  }
  
  .QueryContItemTit div {
    margin-right: 20px;
  }
  
  .QueryContItemTit div:last-child {
    margin-right: 0;
  }
  
  .QueryContItemCont {
    padding: 20px 0;
    display: flex;
  }
  
  .QueryContItemTxt {
    flex: 1;
    line-height: 30px;
    font-size: 16px;
    color: #737373;
  }
  
  /* Publicity 原有样式 */
  .QueryCont {
    margin-top: 20px;
  }
  
  .QueryCard {
    display: flex;
    flex-direction: column;
    border: 1px solid #ddd;
    margin-bottom: 20px;
    padding: 20px;
    background: #fff;
    cursor: pointer;
  }
  
  .QueryCard:hover {
    background: #f5f5f5;
  }
  
  .QueryCardContent {
    display: flex;
    flex-direction: column;
  }
  
  .QueryCardTitle {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 5px;
  }
  
  .QueryCardSubtitle {
    font-size: 16px;
    color: #666;
    margin-bottom: 5px;
  }
  
  .State {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  
  .StateTit {
    font-weight: 400;
    font-size: 16px;
    color: #999;
  }
  
  .StateTag {
    margin-left: 10px;
    padding: 3px 15px;
  }
  
  .StateTag.BgBlue {
    background: #e8f3fc;
    border: 1px solid #9cc1f1;
    color: #3a83e4;
  }
  
  .StateTag.BgGreen {
    background: #E4F9EF;
    border: 1px solid #A4EACA;
    color: #49D696;
  }
  
  .StateTag.BgRed {
    background: #fac2c2;
    border: 1px solid #d51938;
    color: #d51938;
  }
  
  .PageDis {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
  }
  
  @media only screen and (max-width: 550px) {
    .Nav {
      flex-wrap: wrap;
    }
    .NavItem {
      flex: 1;
      padding: 10px;
    }
    .QueryContItemTit {
      justify-content: space-between;
    }
    .QueryContItemTit div {
      margin: 0;
    }
  }
  </style>